import React, { Component } from "react";
import { connect } from "react-redux";
import Routes from "./components/Routes";
import {
  nonFastTrackModules,
  travelOrEapModules,
  nonHowToClaimsModules,
  nonClaimsModules
} from "./constants/SMEModulesToMatchOn";
import { shouldShowIfAllSMEModulesDontMatch } from "./helpers/SMEModules/smeModuleHelper";
import NonceHelper from "./helpers/NonceHelper";

export class App extends Component {
  render() {
    return (
      <>
      <NonceHelper/>
      <Routes
        history={this.props.history}
        shouldShowFastTrack={this.props.shouldShowFastTrack}
        shouldShowClaims={this.props.shouldShowClaims}
        shouldOnlyShowHowToClaims={this.props.shouldOnlyShowHowToClaims}
        shouldShowHowToClaim={this.props.shouldShowHowToClaim}
      />
      </>
    );
  }
}

export const mapStateToApp = ({ policyReducer }) => {
  const { selectedPolicy } = policyReducer;
  return {
    shouldShowHowToClaim:
      (selectedPolicy && !selectedPolicy.IsSMEModular) ||
      shouldShowIfAllSMEModulesDontMatch(selectedPolicy, nonHowToClaimsModules),
    shouldOnlyShowHowToClaims:
      selectedPolicy &&
      selectedPolicy.IsSMEModular &&
      !shouldShowIfAllSMEModulesDontMatch(selectedPolicy, travelOrEapModules),
    shouldShowFastTrack: shouldShowIfAllSMEModulesDontMatch(
      selectedPolicy,
      nonFastTrackModules
    ),
    shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
      selectedPolicy,
      nonClaimsModules
    )
  };
};

export default connect(mapStateToApp)(App);
